import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.values = this.el.dataset.values;
        this.selectors = this.el.dataset.selectors;
        if( this.values && this.selectors ){
            this.values = this.values.split( ',' );
            this.selectors = this.selectors.split( ',' );
            if(this.values.length === this.selectors.length ){
                this.buildField();
            } else{
                console.warn('on values / selectors mismatch', this.el );
            }
        }
    }

    buildField(){
         [ ... this.el.querySelectorAll( '[name]' )].forEach( field => {

             field.addEventListener( 'change', e => {
                 let currentValue = field.value;

                 this.values.forEach( (value, index ) => {
                     let elements = [...document.querySelectorAll( this.selectors[ index ] )];
                     elements.forEach( el => {
                         el.classList.toggle( 'hidden', currentValue !== value);
                         el.dataset.validateGroup = currentValue === value;
                     })

                 });
             });
         });
    }
}
